import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

import { SharedModule } from '../shared/shared.module';
import { LAYOUT_LUCIDE_ICONS } from './layout-icons';
import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AvdIframeComponent } from './avd-iframe/avd-iframe.component';
import { NavFlyoutComponent } from '@shared/components/nav-flyout/nav-flyout.component';
import { MenuDrawerComponent } from '@shared/components/menu-drawer/menu-drawer.component';
import { NotificationBellDropdownComponent } from '@shared/components/notification-bell-dropdown/notification-bell-dropdown.component';


@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    AvdIframeComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    NavFlyoutComponent,
    MenuDrawerComponent,
    NotificationBellDropdownComponent,
    // The overlay pages (Health Facilities, Collection Queues, Cash Control,
    // Laboratory Sectors, Clinics) are NOT imported here: LayoutComponent loads them on
    // first open through LAYOUT_OVERLAY_LOADERS (layout-overlays.ts), keeping
    // them out of the initial bundle.
    // Every icon the layout and the pages it mounts render: see layout-icons.ts.
    LucideAngularModule.pick(LAYOUT_LUCIDE_ICONS)
  ],
  exports: [
    LayoutComponent
  ]
})
export class LayoutModule { }
